import { create } from 'zustand';

interface LayoutStoreType {
  topbarHidden: boolean;
  setTopbarHidden: (value: boolean) => void;
}

export const useLayoutStore = create<LayoutStoreType>((set) => ({
  topbarHidden: false,
  setTopbarHidden: (value: boolean) => set({ topbarHidden: value }),
}));
